<!-- Header Row -->
<div class="flex justify-between lg:flex-row flex-col lg:items-center mb-5 gap-4">

    <!-- Search input -->
    <app-search placeholder="TABLE.SEARCH" (searchChange)="onSearchChange($event)" extraClass="lg:max-w-xl w-full"></app-search>

    <div class="flex gap-2 lg:self-auto self-end sm:flex-row flex-row-reverse shrink-0">

        <app-filter [filterOptions]="filterOptions" [defaultFilter]="defaultFilter" (apply)="onApplyFilters($event)"
            (reset)="onResetFilters()"></app-filter>

        <!-- Edit/Create Button (optional) -->
        <button *ngIf="showCreate"
            class="flex items-center gap-2 text-white font-medium text-base px-5 py-2 rounded-2xl cursor-pointer transition"
            style="background: var(--btn-bg-gradient);" (click)="onCreateClick()">
            <img src="assets/icons/add-white.svg" class="w-3 h-3" />
            {{'TABLE.CREATE' | translate}}
        </button>
    </div>
</div>

<div class="overflow-x-auto">

    <!-- HEADER -->
    <div class="grid min-w-[805px] border-b-[0.5px] border-[#DAE1E4] mb-6 py-3 px-4 gap-4"
        [ngStyle]="{ 'grid-template-columns': gridTemplateColumns }">
        <ng-container *ngFor="let col of columns; let i = index">
            <div [ngClass]="[
            col.gridClass
        ]" class=" font-medium text-base text-(--text-muted)">
                {{ col.label | translate }}
            </div>
        </ng-container>

    </div>

    <!-- BODY -->
    <div *ngFor="let row of data; let rowIndex = index" class="min-w-[800px]">

        <div class="border-[0.5px] border-[#DAE1E4] bg-white rounded-2xl grid text-medium gap-4
                     mb-4 py-[27px] px-4" [ngStyle]="{ 'grid-template-columns': gridTemplateColumns }">

            <!-- LOOP COLUMNS -->
            <ng-container *ngFor="let col of columns; let i= index">

                <div [ngClass]="[col.gridClass, i === 0 ? '' : '']">

                    <!-- APPLY NG SWITCH HERE -->
                    <ng-container [ngSwitch]="col.key">

                        <!-- AMOUNT -->
                        <span *ngSwitchCase="'amount'" [ngClass]="{ 
        'text-(--color-error)': Number(row[col.key]) < 0,
        'text-(--text-placeholder)': row.status === 'Rejected'
      }">
                            {{ row[col.key] }}
                            <ng-container *ngIf="row[col.key] !== 'N/A'">JOD</ng-container>
                        </span>

                        <!-- STATUS -->
                        <ng-container *ngSwitchCase="'status'" class="px-3 py-1 rounded-full text-xs">
                            <app-status-badge [status]="row[col.key]"></app-status-badge>
                        </ng-container>

                        <!-- ACTIONS -->
                        <ng-container *ngSwitchCase="'actions'">
                            <ng-container *ngIf="hasValidActions(row[col.key])" class="text-end">

                                <button cdkOverlayOrigin #trigger="cdkOverlayOrigin" type="button"
                                    class="flex justify-end ltr:ml-auto rtl:mr-auto cursor-pointer"
                                    (click)="openDropdown(row[col.key], trigger)">

                                    <img class="w-4 h-4" src="assets/icons/vertical-ellipsis.svg" alt="Menu icon" />

                                </button>

                            </ng-container>
                        </ng-container>


                        <!-- DEFAULT -->
                        <span *ngSwitchCase="'createdOn'" class="truncate block overflow-hidden whitespace-nowrap">
                            {{ row[col.key] | date : 'dd MMM yyyy'}}
                        </span>

                        <!-- DEFAULT -->
                        <span *ngSwitchDefault class="truncate block overflow-hidden whitespace-nowrap">
                            {{ row[col.key] }}
                        </span>

                    </ng-container>
                </div>

            </ng-container>
        </div>

    </div>

</div>


<!-- Pagination -->
<div *ngIf="showPagination"
    class="flex justify-between items-center sm:mt-2 mt-4 font-medium sm:flex-row flex-col gap-4">
    <div class="flex items-center gap-3 text-base sm:order-1 order-2">

        <!-- Prev Button -->
        <button class="text-blue-500 flex items-center gap-3 cursor-pointer disabled:opacity-40 disabled:cursor-auto"
            [disabled]="page === 1" (click)="changePage(page - 1)">
            <img src="assets/icons/arrow-left-blue.svg" alt="arrow-left" [class.opacity-40]="page === 1" />
            {{'TABLE.PREV' | translate}}
        </button>

        <span
            class="px-2 py-1 min-w-10 rounded-xl shadow-(--shadow-input) flex items-center justify-center text-medium">
            {{ page }}
        </span>

        <!-- Next Button -->
        <button class="text-blue-500 flex items-center gap-3 cursor-pointer disabled:opacity-40 disabled:cursor-auto"
            [disabled]="page * pageSize >= totalRecords" (click)="changePage(page + 1)">
            {{'TABLE.NEXT' | translate}}
            <img src="assets/icons/arrow-right-blue.svg" alt="arrow-right"
                [class.opacity-40]="page * pageSize >= totalRecords" />
        </button>
    </div>

    <div class="text-(--text-placeholder) text-sm font-medium sm:order-2 order-1">
        {{'TABLE.SHOWING' | translate}} {{ (page - 1) * pageSize + 1 }} -
        {{ Math.min(page * pageSize, totalRecords) }}
        {{'TABLE.OF' | translate}} {{ totalRecords }}
    </div>
</div>

<!-- dropdown menu -->
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="overlayOrigin" [cdkConnectedOverlayOpen]="isDropdownOpen"
    [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="closeDropdown()" (detach)="closeDropdown()">

    <div class="dropdown-menu text-medium shadow-(--shadow-input) flex flex-col 
         text-start bg-white rounded-3xl py-6 px-5 min-w-[230px]">

        <button *ngFor="let item of dropdownActions" class="cursor-pointer text-start border-b text-medium last:border-b-0 border-(--border-color)
             py-5 px-3 hover:opacity-86" [ngClass]="{ 'text-(--color-error)': item.label === 'Delete role' }"
            (click)="onActionClick(item)">

            {{ item.label | translate}}

        </button>
    </div>

</ng-template>